/**
 * MD5 hash service which wraps md5-js libary https://github.com/emn178/js-md5
 */
export const Md5Provider = {
  provide: 'md5',
  useValue: require('js-md5'),
};
